class Level {
    id;
    name;
    fixedPay;
    fixedSalary;
    fixedVariableSalary;
    hours;
    payRate;
    pension;
    from;
    to;
    vacationDays;
    maxBonus;
    workPercentage;
    constructor(levelJson) {
        this.name = levelJson.name || '';
        this.fixedPay = levelJson.fixedPay || 0;
        this.fixedSalary = levelJson.fixedSalary || null;
        this.fixedVariableSalary = levelJson.fixedVariableSalary || null;
        this.hours = levelJson.hours || 0;
        this.id = levelJson.id;
        this.payRate = levelJson.payRate || 0;
        this.pension = levelJson.pension || 0;
        this.from = window.dateHandler.convertToUTCTime(levelJson.from) || null;
        this.to = window.dateHandler.convertToUTCTime(levelJson.to) || null;
        this.vacationDays = levelJson.vacationDays || 0;
        this.maxBonus = levelJson.maxBonus || this.fixedPay * 2;
        this.workPercentage = levelJson.workPercentage || 100;
    }
}
export default Level;
